module.exports = "/_next/static/images/trezor_logo_symbol-c39255d175639622008c17f1c0a35f03.svg";